import api from './api';

export const notificationService = {
  async getNotifications() {
    try {
      const response = await api.get('/notifications');
      return response.data;
    } catch (error) {
      // Return empty notifications instead of mock data
      console.warn('Notifications API not yet implemented, returning empty list');
      return {
        notifications: [],
        unreadCount: 0
      };
    }
  },
  
  async markAsRead(notificationId) {
    try {
      const response = await api.put(`/notifications/${notificationId}/read`);
      return response.data;
    } catch (error) {
      console.warn('Mark as read API not yet implemented');
      return {
        id: notificationId,
        isRead: true
      };
    }
  },
  
  async markAllAsRead() {
    try {
      const response = await api.put('/notifications/read-all');
      return response.data;
    } catch (error) {
      console.warn('Mark all as read API not yet implemented');
      return {
        message: 'All notifications marked as read',
        count: 0
      };
    }
  }
};
